export class Unsubscriber {
    unsubscriberId: number;
    unsubscribeType: string;
    phoneNumber: string;
    email: string;
    reason: string;
    effectiveDate: Date;
    endDate: Date;
}